export default "__VITE_ASSET__5f4d91c3__"